import { ILazyloadConfiguration } from "@almamedia/amr-adtech-stack/lib/services/lazyload";

const lazyload: ILazyloadConfiguration = {
  enabled: true,
  defaults: {
    offset: {
      top: 150,
      bottom: 150,
    },
  },
};

export default lazyload;
